import { Injectable } from '@angular/core';
import { IDiagnosticsService } from './interfaces';
import { DefaultDiagnosticsService } from './default-diagnostics-service';

/**
 * An injectable singleton factory, which creates a component-specific instance
 * of IDiagnosticsService implementation.
 * Change the logLevel property to control number of messages captured by
 * diagnostics service instances. Supported values are DEBUG, WARNING, ERROR.
 */
@Injectable()
export class DiagnosticsServiceFactory {
  public create(scope: string): IDiagnosticsService {
    return new DefaultDiagnosticsService(scope, {logLevel: 'DEBUG'});
  }
}
